<template lang="html">
  <section class="app-create-mail">
    <p class="text-success" v-if="messageSubmission">
      <strong v-html="messageSubmission"></strong>
    </p>
    <form @submit.prevent="onSubmit" class="text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <fieldset class="pl-3 pr-3">
        <legend class="text-center">Server settings</legend>
        <div class="form-group d-flex">
          <label for="mailSmtpHost" class="w-25 align-self-center">* SMTP Host :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailSmtpHost.$touch()" v-model="dataForm.mailSmtpHost"
                   :class="$v.dataForm.mailSmtpHost.$error ? 'is-invalid': ''" id="mailSmtpHost"
                   type="text" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailSmtpHost.required">Please enter server hostname !</div>
              <div v-if="!$v.dataForm.mailSmtpHost.minLength || !$v.dataForm.mailSmtpHost.maxLength">
                Length of the server hostname must be between {{$v.dataForm.mailSmtpHost.$params.minLength.min}} and
                {{$v.dataForm.mailSmtpHost.$params.maxLength.max}} characters !
              </div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <div class="w-25 align-self-center">* SMTP Auth: </div>
          <div class="w-90">
            <div class="custom-control custom-radio custom-control-inline">
              <input v-model="dataForm.mailSmtpAuth" value="1" type="radio"
                     id="SmtpAuthTrue" class="custom-control-input">
              <label class="custom-control-label" for="SmtpAuthTrue">True</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input v-model="dataForm.mailSmtpAuth" value="0" type="radio"
                     id="SmtpAuthFalse" class="custom-control-input">
              <label class="custom-control-label" for="SmtpAuthFalse">False</label>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailSmtpUsername" class="w-25 align-self-center">* SMTP Username :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailSmtpUsername.$touch()" v-model="dataForm.mailSmtpUsername"
                   :class="$v.dataForm.mailSmtpUsername.$error ? 'is-invalid': ''" id="mailSmtpUsername"
                   type="text" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailSmtpUsername.required">Please enter username for connecting to the server !</div>
              <div v-if="!$v.dataForm.mailSmtpUsername.email">Please enter a valid username address !</div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailSmtpPassword" class="w-25 align-self-center">* SMTP Password :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailSmtpPassword.$touch()" v-model="dataForm.mailSmtpPassword"
                   :class="$v.dataForm.mailSmtpPassword.$error ? 'is-invalid': ''" id="mailSmtpPassword"
                   type="password" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailSmtpPassword.required">A password is required for connecting to the server !</div>
              <div v-if="!$v.dataForm.mailSmtpPassword.minLength || !$v.dataForm.mailSmtpPassword.maxLength">
                Password must contain between {{$v.dataForm.mailSmtpPassword.$params.minLength.min}} and
                {{$v.dataForm.mailSmtpPassword.$params.maxLength.max}} characters
              </div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailSmtpSecure" class="w-25 align-self-center">* SMTP Secure :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailSmtpSecure.$touch()" v-model="dataForm.mailSmtpSecure"
                   :class="$v.dataForm.mailSmtpSecure.$error ? 'is-invalid': ''" id="mailSmtpSecure"
                   type="text" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailSmtpSecure.required">Please enter type of your server security !</div>
              <div v-if="!$v.dataForm.mailSmtpSecure.validValue">This type of security is not recognized !</div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailSmtpPort" class="w-25 align-self-center">* SMTP Port :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailSmtpPort.$touch()" v-model="dataForm.mailSmtpPort"
                   :class="$v.dataForm.mailSmtpPort.$error ? 'is-invalid': ''" id="mailSmtpPort"
                   type="number" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailSmtpPort.required">Server port number is required !</div>
              <div v-if="!$v.dataForm.mailSmtpPort.numeric">Server port value must be numeric !</div>
              <div v-if="!$v.dataForm.mailSmtpPort.minLength || !$v.dataForm.mailSmtpPort.maxLength">
                The number of digits of the server port number must be between {{$v.dataForm.mailSmtpPort.$params.minLength.min}} and
                {{$v.dataForm.mailSmtpPort.$params.maxLength.max}} !
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="pl-3 pr-3">
        <legend class="text-center">Recipients</legend>
        <div class="form-group d-flex">
          <label for="mailSetFromEmail" class="w-25 align-self-center">* Set From Email :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailSetFromEmail.$touch()" v-model="dataForm.mailSetFromEmail"
                   :class="$v.dataForm.mailSetFromEmail.$error ? 'is-invalid': ''" id="mailSetFromEmail"
                   type="email" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailSetFromEmail.required">Set from email is required !</div>
              <div v-if="!$v.dataForm.mailSetFromEmail.email">Please enter a valid set from email address !</div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailSetFromName" class="w-25 align-self-center">* Set From Name :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailSetFromName.$touch()" v-model="dataForm.mailSetFromName"
                   :class="$v.dataForm.mailSetFromName.$error ? 'is-invalid': ''" id="mailSetFromName"
                   type="text" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailSetFromName.required">Set from name is required !</div>
              <div v-if="!$v.dataForm.mailSetFromName.minLength || !$v.dataForm.mailSetFromName.maxLength">
                Set from name length must be between {{$v.dataForm.mailSetFromName.$params.minLength.min}} and
                {{$v.dataForm.mailSetFromName.$params.maxLength.max}} characters !
              </div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailRecipientEmail" class="w-25 align-self-center">* Recipient Email :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailRecipientEmail.$touch()" v-model="dataForm.mailRecipientEmail"
                   :class="$v.dataForm.mailRecipientEmail.$error ? 'is-invalid': ''" id="mailRecipientEmail"
                   type="email" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailRecipientEmail.required">Recipient email address is required !</div>
              <div v-if="!$v.dataForm.mailRecipientEmail.email">Please enter a valid email address !</div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailRecipientName" class="w-25 align-self-center">* Recipient Name :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailRecipientName.$touch()" v-model="dataForm.mailRecipientName"
                   :class="$v.dataForm.mailRecipientName.$error ? 'is-invalid': ''" id="mailRecipientName"
                   type="text" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailRecipientName.required">Recipient name is required !</div>
              <div v-if="!$v.dataForm.mailRecipientName.minLength || !$v.dataForm.mailRecipientName.maxLength">
                Recipient name length must be between {{$v.dataForm.mailRecipientName.$params.minLength.min}} and
                {{$v.dataForm.mailRecipientName.$params.maxLength.max}} characters !
              </div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailReplyToEmail" class="w-25 align-self-center">* Reply to Email :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailReplyToEmail.$touch()" v-model="dataForm.mailReplyToEmail"
                   :class="$v.dataForm.mailReplyToEmail.$error ? 'is-invalid': ''" id="mailReplyToEmail"
                   type="email" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailReplyToEmail.required">Email address to reply to is required !</div>
              <div v-if="!$v.dataForm.mailReplyToEmail.email">Please enter a valid email address !</div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailReplyToName" class="w-25 align-self-center">* Reply to Name :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailReplyToName.$touch()" v-model="dataForm.mailReplyToName"
                   :class="$v.dataForm.mailReplyToName.$error ? 'is-invalid': ''" id="mailReplyToName"
                   type="text" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailReplyToName.required">Name of the person to reply is required !</div>
              <div v-if="!$v.dataForm.mailReplyToName.minLength || !$v.dataForm.mailReplyToName.maxLength">
                Name length must be between {{$v.dataForm.mailReplyToName.$params.minLength.min}} and
                {{$v.dataForm.mailReplyToName.$params.maxLength.max}} characters !
              </div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailCcEmail" class="w-25 align-self-center">Cc Email :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailCcEmail.$touch()" v-model="dataForm.mailCcEmail"
                   :class="$v.dataForm.mailCcEmail.$error ? 'is-invalid': ''" id="mailCcEmail"
                   type="email" class="form-control">
            <div class="invalid-feedback">Please enter a valid Cc email address !</div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailCcName" class="w-25 align-self-center">Cc Name :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailCcName.$touch()" v-model="dataForm.mailCcName"
                   :class="$v.dataForm.mailCcName.$error ? 'is-invalid': ''" id="mailCcName"
                   type="text" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailCcName.minLength || !$v.dataForm.mailCcName.maxLength">
                Cc name length must be between {{$v.dataForm.mailCcName.$params.minLength.min}} and
                {{$v.dataForm.mailCcName.$params.maxLength.max}} characters !
              </div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailBccEmail" class="w-25 align-self-center">Bcc Email :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailBccEmail.$touch()" v-model="dataForm.mailBccEmail"
                   :class="$v.dataForm.mailBccEmail.$error ? 'is-invalid': ''" id="mailBccEmail"
                   type="email" class="form-control">
            <div class="invalid-feedback">Please enter a valid email address !</div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailBccName" class="w-25 align-self-center">Bcc Name :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailBccName.$touch()" v-model="dataForm.mailBccName"
                   :class="$v.dataForm.mailBccName.$error ? 'is-invalid': ''" id="mailBccName"
                   type="text" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailBccName.minLength || !$v.dataForm.mailBccName.maxLength">
                Bcc name length must be between {{$v.dataForm.mailBccName.$params.minLength.min}} and
                {{$v.dataForm.mailBccName.$params.maxLength.max}} characters !
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="pl-3 pr-3">
        <legend class="text-center">Attachments</legend>
        <div class="form-group d-flex">
          <label for="mailAttachments" class="w-25 align-self-center">Attachments :</label>
          <div class="w-100">
            <input v-model="dataForm.mailAttachments" id="mailAttachments" type="text" class="form-control">
          </div>
        </div>
      </fieldset>
      <fieldset class="pl-3 pr-3">
        <legend class="text-center">Content</legend>
        <div class="form-group d-flex">
          <div class="w-25 align-self-center">* Is HTML: </div>
          <div class="w-90">
            <div class="custom-control custom-radio custom-control-inline">
              <input v-model="dataForm.mailIsHtml" value="1" type="radio"
                     id="isHtmlTrue" class="custom-control-input">
              <label class="custom-control-label" for="isHtmlTrue">True</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input v-model="dataForm.mailIsHtml" value="0" type="radio"
                     id="isHtmlFalse" class="custom-control-input">
              <label class="custom-control-label" for="isHtmlFalse">NO</label>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailSubject" class="w-25 align-self-center">* Subject :</label>
          <div class="w-100">
            <input @blur="$v.dataForm.mailSubject.$touch()" v-model="dataForm.mailSubject"
                   :class="$v.dataForm.mailSubject.$error ? 'is-invalid': ''" id="mailSubject"
                   type="text" class="form-control">
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailSubject.required">Please enter an object or subject of your mail !</div>
              <div v-if="!$v.dataForm.mailSubject.minLength || !$v.dataForm.mailSubject.maxLength">
                Subject of the mail length must be between {{$v.dataForm.mailSubject.$params.minLength.min}} and
                {{$v.dataForm.mailSubject.$params.maxLength.max}} characters !
              </div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailBody" class="w-25 align-self-center">* Body :</label>
          <div class="w-100">
            <textarea @blur="$v.dataForm.mailBody.$touch()" v-model="dataForm.mailBody"
                      :class="$v.dataForm.mailBody.$error ? 'is-invalid': ''" class="form-control"
                      rows="5" id="mailBody" placeholder="Enter text here...">
            </textarea>
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailBody.required">Body of the mail is require !</div>
              <div v-if="!$v.dataForm.mailBody.minLength">
                Body of te mail can not be less than {{$v.dataForm.mailBody.$params.minLength.min}} characters !
              </div>
            </div>
          </div>
        </div>
        <div class="form-group d-flex">
          <label for="mailAltBody" class="w-25 align-self-center">* Alt Body :</label>
          <div class="w-100">
            <textarea @blur="$v.dataForm.mailAltBody.$touch()" v-model="dataForm.mailAltBody"
                      :class="$v.dataForm.mailAltBody.$error ? 'is-invalid': ''" class="form-control"
                      rows="5" id="mailAltBody" placeholder="Enter text here...">
            </textarea>
            <div class="invalid-feedback">
              <div v-if="!$v.dataForm.mailAltBody.required">Alternative Body text message is required !</div>
              <div v-if="!$v.dataForm.mailAltBody.minLength">
                The length of the alternative body text message must not be less than
                {{$v.dataForm.mailAltBody.$params.minLength.min}}
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <div class="mt-4 mb-4 text-center">
        <button :class="$v.dataForm.$invalid ? 'cursor-pointer-disabled':''"
                :disabled="$v.dataForm.$invalid" type="submit" class="btn btn-success">
          Submit
        </button>
        <button type="button" class="btn btn-danger ml-3" @click="resetForm">
          Reset
        </button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {uuid} from 'vue-uuid'
import {mapGetters, mapActions} from "vuex";
import {FORM_MAILS_VALIDATIONS} from '../../validations/formMails'

export default {
  name: 'CreateNews',
  props: [],
  mounted () {},
  created () {},
  validations: FORM_MAILS_VALIDATIONS,
  data () {
    return {
      dataForm: {
        mailId: uuid.v4(),
        mailSmtpHost: 'smtp.hostinger.com',
        mailSmtpAuth: 1,
        mailSmtpUsername: 'contact@ridiluamba.com',
        mailSmtpPassword: '12C;44w/XX:H!IG7>B',
        mailSmtpSecure: 'ssl',
        mailSmtpPort: 465,
        mailSetFromEmail: 'contact@ridiluamba.com',
        mailSetFromName: 'Ridi Luamba',
        mailRecipientEmail: 'ridiluamba@gmail.com',
        mailRecipientName: 'Ridi Luamba',
        mailReplyToEmail: 'contact@ridiluamba.com',
        mailReplyToName: 'Ridi Luamba',
        mailCcEmail: undefined,
        mailCcName: undefined,
        mailBccEmail: undefined,
        mailBccName: undefined,
        mailAttachments: undefined,
        mailIsHtml: 1,
        mailSubject: 'Testing mailing service',
        mailBody: '<b>some random text here or some lorem ipsum</b>',
        mailAltBody: 'some random text here or some lorem ipsum'
      },
      messageSubmission: ""
    }
  },
  methods: {
    ...mapActions([
      'createData',
      'sendMail'
    ]),
    onSubmit () {
      const formData = {
        mail_id: this.dataForm.mailId,
        smtp_host: this.dataForm.mailSmtpHost,
        smtp_auth: Number(this.dataForm.mailSmtpAuth) === 1,
        smtp_username: this.dataForm.mailSmtpUsername,
        smtp_password: this.dataForm.mailSmtpPassword,
        smtp_secure: this.dataForm.mailSmtpSecure,
        smtp_port: Number(this.dataForm.mailSmtpPort),
        set_from_email: this.dataForm.mailSetFromEmail,
        set_from_name: this.dataForm.mailSetFromName,
        recipient_email: this.dataForm.mailRecipientEmail,
        recipient_name: this.dataForm.mailRecipientName,
        reply_to_email: this.dataForm.mailReplyToEmail,
        reply_to_name: this.dataForm.mailReplyToName,
        cc_email: this.dataForm.mailCcEmail,
        cc_name: this.dataForm.mailCcName,
        bcc_email: this.dataForm.mailBccEmail,
        bcc_name: this.dataForm.mailBccName,
        attachments: this.dataForm.mailAttachments,
        is_html: Number(this.dataForm.mailIsHtml) === 1,
        subject: this.dataForm.mailSubject,
        body: this.dataForm.mailBody,
        alt_body: this.dataForm.mailAltBody
      };
      this.dataForm.mailId = uuid.v4();
      //
      this.sendMail({url: 'send_mail', data: formData})
        .then(data => {
          this.messageSubmission = data;
        })
        .catch(data => console.log(data));
      this.createData(formData)
        .then(data => {
          this.messageSubmission += "<br>" + data;
        })
        .catch(data => console.log(data));
      //
      this.sendMail({url: 'send_mail_user', data: formData})
        .then(data => {
          this.messageSubmission += "<br>" + data;
          setTimeout( () => {
            this.messageSubmission = '';
            this.resetForm();
          }, 5000);
        })
        .catch(data => console.log(data));
    },
    resetForm () {
      this.dataForm.mailId = uuid.v4();
      this.dataForm.mailSmtpHost = undefined;
      this.dataForm.mailSmtpAuth = undefined;
      this.dataForm.mailSmtpUsername = undefined;
      this.dataForm.mailSmtpPassword = undefined;
      this.dataForm.mailSmtpSecure = undefined;
      this.dataForm.mailSmtpPort = undefined;
      this.dataForm.mailSetFromEmail = undefined;
      this.dataForm.mailSetFromName = undefined;
      this.dataForm.mailRecipientEmail = undefined;
      this.dataForm.mailRecipientName = undefined;
      this.dataForm.mailReplyToEmail = undefined;
      this.dataForm.mailReplyToName = undefined;
      this.dataForm.mailCcEmail = undefined;
      this.dataForm.mailCcName = undefined;
      this.dataForm.mailBccEmail = undefined;
      this.dataForm.mailBccName = undefined;
      this.dataForm.mailAttachments = undefined;
      this.dataForm.mailIsHtml = undefined;
      this.dataForm.mailSubject = undefined;
      this.dataForm.mailBody = undefined;
      this.dataForm.mailAltBody = undefined
    }
  },
  computed: {
    ...mapGetters([
      'getNewsTypes'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-create-mail {}
  fieldset {
    border: 1px solid var(--dark-color);
    legend{
      font-weight: bold;
      color: var(--dark-color);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mails/CreateMail.vue